import { UISanctionScreening } from "@flights/types";

export type State = {
  sanctions?: UISanctionScreening[];
};

export const getInitialState = (): State => ({
  sanctions: undefined
});
